import React, { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { Grid, MenuItem, TextField, Typography, CardContent, Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useHistory, useLocation, useNavigate } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import LoaderCircular from 'ui-component/LoaderCircular';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import '../Dashboard/styleSearch.scss';
import { getDynamicColumns } from '../../utils/dynamicColumns';
const columns = [
  // { field: 'id', headerName: 'ID', width: 90 },
  {
    field: 'campaign_name',
    headerName: 'Campaign Name',
    flex: 2,
    minWidth: 200,
    renderCell: (params) => <div className="campaign_name_settings">{params.value}</div>
  },
  {
    field: 'date',
    headerName: 'Date',
    flex: 0.8,
    minWidth: 100,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'country',
    headerName: 'Country',
    flex: 0.8,
    minWidth: 100
  },
  {
    field: 'os_name',
    headerName: 'OS',
    flex: 0.6,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'clicks',
    headerName: 'Clicks',
    valueFormatter: (params) => splitDigits(params.value),
    flex: 1,
    minWidth: 100,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'impressions',
    headerName: 'Impressions',
    valueFormatter: (params) => splitDigits(params.value),
    flex: 1,
    minWidth: 120,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'media_cost',
    headerName: 'Media Cost ($)',
    valueFormatter: (params) => splitDigits(roundToTwoDecimal(params.value)),
    flex: 1,
    minWidth: 140,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'media_cost_local_currency',
    headerName: 'Media Cost (¥)',
    valueFormatter: (params) => splitDigits(roundYen(params.value)),
    flex: 1,
    minWidth: 140,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'installs',
    headerName: 'MMP Installs',
    flex: 1,
    minWidth: 120,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'skan_installs',
    headerName: 'SKAN Installs',
    flex: 1,
    minWidth: 120,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ctr',
    headerName: 'CTR',
    valueFormatter: (params) => roundToTwoDecimalPercent(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpe',
    headerName: 'Total eCPE ($)',
    valueFormatter: (params) => roundToTwoDecimal(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpe_local',
    headerName: 'Total eCPE (¥)',
    valueFormatter: (params) => roundYen(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpi',
    headerName: 'Total eCPI ($)',
    valueFormatter: (params) => roundToTwoDecimal(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpi_local',
    headerName: 'Total eCPI (¥)',
    valueFormatter: (params) => roundYen(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'mmp_ecpe',
    headerName: 'MMP eCPE ($)',
    valueFormatter: (params) => roundToTwoDecimal(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'mmp_ecpe_local',
    headerName: 'MMP eCPE (¥)',
    valueFormatter: (params) => roundYen(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'mmp_ecpi',
    headerName: 'MMP eCPI ($)',
    valueFormatter: (params) => roundToTwoDecimal(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'mmp_ecpi_local',
    headerName: 'MMP eCPI (¥)',
    valueFormatter: (params) => roundYen(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'skan_ecpe',
    headerName: 'SKAN eCPE ($)',
    valueFormatter: (params) => roundToTwoDecimal(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
    // flex:1
  },
  {
    field: 'skan_ecpe_local',
    headerName: 'SKAN eCPE (¥)',
    valueFormatter: (params) => roundYen(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'skan_ecpi',
    headerName: 'SKAN eCPI ($)',
    valueFormatter: (params) => roundToTwoDecimal(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'skan_ecpi_local',
    headerName: 'SKAN eCPI (¥)',
    valueFormatter: (params) => roundYen(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpc',
    headerName: 'eCPC ($)',
    valueFormatter: (params) => roundToTwoDecimal(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpc_local',
    headerName: 'eCPC (¥)',
    valueFormatter: (params) => roundYen(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpm',
    headerName: 'eCPM ($)',
    valueFormatter: (params) => roundToTwoDecimal(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  },
  {
    field: 'ecpm_local',
    headerName: 'eCPM (¥)',
    valueFormatter: (params) => roundYen(params.value),
    flex: 0.8,
    minWidth: 80,
    align: 'center',
    headerAlign: 'center'
  }
];
function splitDigits(num) {
  return Number(num).toLocaleString();
}
function roundToTwoDecimal(value) {
  if (value == '-999') return '-';
  // return Math.round((value + Number.EPSILON) * 100) / 100;
  return (Math.round((value + Number.EPSILON) * 10000) / 10000).toFixed(4);
}
function roundToTwoDecimalPercent(value) {
  if (value == '-999') return '-';
  // const roundedValue = Math.round((value * 100 + Number.EPSILON) * 100) / 100; // Multiply by 100 to convert to percentage
  // return `${roundedValue}%`; // Append '%' sign
  const roundedValue = Math.round((value * 100 + Number.EPSILON) * 10000) / 10000;
  return `${roundedValue.toFixed(4)}%`;
}
function roundYen(value) {
  if (value == '-999') return '-';
  return Math.round(value);
}
const DodDataSkanView = ({ dodData, loading, campaign_list, isSkan, end_date, start_date, error, timeZone, isDollar }) => {
  console.log('JST DOD SKAN overview');

  const location = useLocation();
  let currentPath = location.pathname.split('/')[1];

  useEffect(() => {
    //fetchDataForReportingDatatable();
    // fetchReportData()
    if (campaign_list.length > 0) {
      //console.log(campaign_list)
      //let campaignIds=campaign_list.map(value=>value.campaignGuid)
      //fetchReportData(campaign_list)
    }
  }, [campaign_list, isSkan, end_date, start_date]);

  const dynamicColumns = useMemo(() => {
    return getDynamicColumns(columns, dodData);
  }, [dodData]);

  console.log(dodData.length);
  console.log('DoD data skan===>', dodData);
  const getRowHeight = (params) => {
    const column2Value = params.model.campaign_name;
    //console.log(column2Value);
    if (column2Value.length > 110) {
      return 150; // Return the desired row height in pixels
    } else if (column2Value.length > 100) {
      return 130; // Return the desired row height in pixels
    } else {
      return 50;
    }
  };
  const columnVisibilityModel = React.useMemo(() => {
    let visibility = {
      media_cost_local_currency: false,
      media_cost: true,
      installs: true, // Default: show MMP and SKAN fields
      mmp_ecpe: true,
      mmp_ecpi: true,
      skan_ecpe: true,
      skan_ecpi: true,
      ecpc_local: false,
      ecpc: true,
      ecpm_local: false,
      ecpm: true,
      ecpe_local: false,
      ecpe: true,
      ecpi_local: false,
      ecpi: true,
      mmp_ecpe_local: false,
      mmp_ecpi_local: false,
      skan_ecpe_local: false,
      skan_ecpi_local: false
    };

    if (timeZone === 'JST') {
      visibility.installs = false; // Hide MMP & SKAN fields for JST
      visibility.mmp_ecpe = false;
      visibility.mmp_ecpi = false;
      visibility.skan_ecpe = false;
      visibility.skan_ecpi = false;

      if (isDollar) {
        visibility.media_cost_local_currency = false;
        visibility.media_cost = true;
        visibility.ecpc_local = false;
        visibility.ecpc = true;
        visibility.ecpm_local = false;
        visibility.ecpm = true;
        visibility.ecpe_local = false;
        visibility.ecpe = true;
        visibility.ecpi_local = false;
        visibility.ecpi = true;
        visibility.mmp_ecpe_local = false;
        visibility.mmp_ecpi_local = false;
        visibility.skan_ecpe_local = false;
        visibility.skan_ecpi_local = false;
      } else {
        visibility.media_cost_local_currency = true;
        visibility.media_cost = false;
        visibility.ecpc_local = true;
        visibility.ecpc = false;
        visibility.ecpm_local = true;
        visibility.ecpm = false;
        visibility.ecpe_local = true;
        visibility.ecpe = false;
        visibility.ecpi_local = true;
        visibility.ecpi = false;
        visibility.mmp_ecpe_local = false;
        visibility.mmp_ecpi_local = false;
        visibility.skan_ecpe_local = false;
        visibility.skan_ecpi_local = false;
      }
    }

    return visibility;
  }, [timeZone, isDollar]);

  //console.log('cc', campaign_list, loading);
  return (
    <>
      {loading ? (
        <MainCard>
          <Grid container spacing={gridSpacing}>
            <Grid item lg={12} md={12} sm={12} xs={12} alignContent="center" sx={{ textAlign: 'center' }}>
              <Typography variant="h4">Day-On-Day Report</Typography>
            </Grid>

            <Grid item xs={12} alignContent="center" sx={{ textAlign: 'center' }}>
              <div style={{ height: '200px', width: '100%' }}>
                {' '}
                <LoaderCircular show={true} />
              </div>
            </Grid>
          </Grid>
        </MainCard>
      ) : dodData == 0 || campaign_list.length == 0 ? (
        <MainCard>
          <Grid container spacing={gridSpacing}>
            <Grid item lg={12} md={12} sm={12} xs={12} alignContent="center" sx={{ textAlign: 'center' }}>
              <Typography variant="h4">Day-On-Day Report</Typography>
            </Grid>

            <Grid item xs={12} alignContent="center" sx={{ textAlign: 'center' }}>
              <Typography style={{ textAlign: 'center' }}>
                {/* Please click <b>Apply Filter</b> to view data */}
                {error.length != 0 ? (
                  'No Data Found'
                ) : (
                  <span>
                    Please click <b>Apply Filter</b> to view data
                  </span>
                )}
              </Typography>
            </Grid>
          </Grid>
        </MainCard>
      ) : (
        <MainCard>
          <Grid container spacing={gridSpacing}>
            <Grid item lg={12} md={12} sm={12} xs={12} alignContent="center" sx={{ textAlign: 'center' }}>
              <Typography variant="h4">Day-On-Day Report</Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container alignItems="center" justifyContent="space-between">
                <Grid item xs={12}>
                  <Box>
                    <div style={{ minHeight: '400px', width: '100%' }}>
                      <style>
                        {`
                          .custom-datagrid {
                            width: 100% !important;
                          }
                          .custom-datagrid .MuiDataGrid-main {
                            width: 100% !important;
                          }
                          .custom-datagrid .MuiDataGrid-virtualScroller {
                            width: 100% !important;
                          }
                        `}
                      </style>
                      {loading ? (
                        <CircularProgress
                          style={{
                            position: 'relative',
                            top: '50%',
                            left: '50%'
                          }}
                        />
                      ) : (
                        <DataGrid
                          rows={dodData}
                          columns={dynamicColumns}
                          initialState={{
                            pagination: {
                              paginationModel: {
                                pageSize: 10
                              }
                            },
                            sorting: {
                              sortModel: [{ field: 'date', sort: 'desc' }] // Default sort on 'cost' column
                            }
                          }}
                          components={{
                            LoadingOverlay: CircularProgress
                          }}
                          loading={loading}
                          pageSizeOptions={[10, 20, 30]}
                          slots={{ toolbar: GridToolbar }}
                          disableRowSelectionOnClick
                          disableColumnSelector
                          disableDensitySelector
                          style={{ minHeight: '100%', width: '100%' }}
                          autoHeight
                          columnVisibilityModel={columnVisibilityModel}
                          //getRowHeight={getRowHeight}
                          getRowHeight={() => 'auto'}
                          className="custom-datagrid"
                        />
                      )}
                    </div>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </MainCard>
      )}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    dodData: state.dodReducer.dodData,
    loading: state.dodReducer.loading,
    campaign_list: state.advertiserReducer.selected_campaigns,
    isSkan: state.campaignReducer.isSkan,
    end_date: state.campaignReducer.end_date,
    start_date: state.campaignReducer.start_date,
    error: state.dodReducer.error,
    error_msg: state.dodReducer.error_msg, // Add this if you need to display the error message
    timeZone: state.advertiserReducer.timeZone,
    isDollar: state.campaignReducer.isDollar
  };
};

export default connect(mapStateToProps, null)(DodDataSkanView);
